import { storeCreator } from '@/utils/store/store.utils';


interface IState {
  highlightId: string;
  setHighlightId: (value: string) => void;
}

const useHighlightNewRoleStore = storeCreator<IState>((set) => ({
  highlightId: '',

  setHighlightId: (value: string) => set(() => ({
    highlightId: value,
  })),

}));

export default useHighlightNewRoleStore;